var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col",staticStyle:{"margin-top":"35px"}},[_c('Header'),_c('div',{staticStyle:{"background-color":"#f7f3fc"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }